import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { css } from "react-emotion";

const buttonStyle = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
  display: inline-block;
  min-width: min-content !important;
`;
const buttonContainer = css`
  display: inline-block;
  letter-spacing: 0.03rem;
  text-transform: none;
`;

const StyledMenu = withStyles()((props) => (
  <Menu
    elevation={0}
    keepMounted
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    PaperProps={{
      style: {
        // maxHeight: ITEM_HEIGHT * 4.5,
        // width: "100%",
      },
    }}
    {...props}
  />
));

export default function MenuDropdown(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { title, options } = props;

  console.dir(options);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={buttonContainer}>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        color="secondary"
        onClick={handleClick}
        className={buttonStyle}
      >
        <span style={{ textTransform: "none" }}>{title}</span>
        <ArrowDropDownIcon fontSize="small" />
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option) => {
          return (
            <MenuItem>
              <ListItemText
                primary={option.listText}
                onClick={option.listFunc}
              />
            </MenuItem>
          );
        })}
      </StyledMenu>
    </div>
  );
}
